export default {
    name: 'calculatorMyco',
    serverName: '​/api/v1/mycological_calculator/mycological_calculator/',
    apiUrl: '/api/v1/mycological_calculator/mycological_calculator/',
    apiGenusUrl: '/api/v1/mycological_calculator/microorganisms_genus/',
    apiMycoUrl: '/api/v1/mycological_calculator/mycobiota_type/'
};
